import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './BlogHeader.css';

const BlogHeader = () => {
  const navigate = useNavigate();
  const { isAuthenticated, user } = useAuth();

  // Helper function to get header button text based on screen size
  const getHeaderButtonText = () => {
    const isMobile = window.innerWidth <= 768;
    if (isAuthenticated) {
      return 'Go to Build';
    } else if (isMobile) {
      return 'Sign In';
    } else {
      return 'Sign In';
    }
  };

  const handleRequestEarlyAccess = () => {
    if (isAuthenticated) {
      navigate('/build');
    } else {
      const isDevelopment = window.location.hostname === 'localhost';
      const oauthUrl = isDevelopment ? 'https://localhost:5001/auth/google' : '/auth/google';
      window.location.href = oauthUrl;
    }
  };

  const handleViewMarketplace = () => {
    navigate('/');
  };

  const handleLogoClick = () => {
    navigate('/');
  };

  return (
    <header className="blog-header">
      <div className="container">
        <div className="header-content">
          <div className="logo" onClick={handleLogoClick}>
            <img 
              src={process.env.PUBLIC_URL + "/YourQuestionsAnsweredLogo.png"} 
              alt="Question Answer Pro Logo" 
              width={32} 
              height={32}
              style={{ objectFit: 'contain' }}
            />
            <span>Question Answer Pro</span>
          </div>
          <nav className="nav-links">
            <a href="/#features">Features</a>
            <a href="/#marketplace">Marketplace</a>
            <a href="/#how-it-works">How It Works</a>
            <a href="/blog" className="active">Blog</a>
          </nav>
          <div className="header-cta">
            <button className="btn-secondary" onClick={handleViewMarketplace}>
              Browse Agents
            </button>
            <button 
              className="btn-primary" 
              style={{ fontSize: !isAuthenticated ? '0.7rem' : '1rem' }}
              onClick={handleRequestEarlyAccess}
            >
              {getHeaderButtonText()}
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default BlogHeader;
